<template>
	<div class="cardHeader" :class="{ inverted: inverted }">
		<div class="headertext">
			<h1>
				{{ headerText }}
				<font-awesome-icon v-if="helpPageName.length > 0" v-tooltip="'View Page Help'" :icon="['far', 'info-circle']" size="xs" @click="getHelp" />
			</h1>
		</div>
		<div class="addon"><slot /></div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
library.add(faInfoCircle)

export default defineComponent({
	name: "CardHeader",
	components: { FontAwesomeIcon },

	props: {
		headerText: {
			type: String,
			default: "Header text",
			required: true,
		},
		helpPageName: {
			type: String,
			default: "",
			required: false,
		},
		inverted: {
			type: Boolean,
		},
	},
	emits: {
		OpenPageHelp(payload: { helpPageName: string; userFriendlyName: string }) {
			return payload
		},
	},
	methods: {
		getHelp() {
			this.$emit("OpenPageHelp", { helpPageName: this.helpPageName, userFriendlyName: this.headerText })
		},
	},
})
</script>

<style scoped></style>
